/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MarkUserStopRequest interface.
 */
export function instanceOfMarkUserStopRequest(value) {
    if (!('composeId' in value) || value['composeId'] === undefined)
        return false;
    return true;
}
export function MarkUserStopRequestFromJSON(json) {
    return MarkUserStopRequestFromJSONTyped(json, false);
}
export function MarkUserStopRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'composeId': json['compose_id'],
    };
}
export function MarkUserStopRequestToJSON(json) {
    return MarkUserStopRequestToJSONTyped(json, false);
}
export function MarkUserStopRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'compose_id': value['composeId'],
    };
}
